import { isFunction, __DEV__, __TEST__, isNumber } from './assertion.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
function runIfFn(valueOrFn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return isFunction(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
function callAllHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function func(event) {
    fns.some(function (fn) {
      fn === null || fn === void 0 ? void 0 : fn(event);
      return event === null || event === void 0 ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll() {
  for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    fns[_key3] = arguments[_key3];
  }
  return function mergedFn(arg) {
    fns.forEach(function (fn) {
      fn === null || fn === void 0 ? void 0 : fn(arg);
    });
  };
}
var compose = function compose(fn1) {
  for (var _len4 = arguments.length, fns = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fns[_key4 - 1] = arguments[_key4];
  }
  return fns.reduce(function (f1, f2) {
    return function () {
      return f1(f2.apply(void 0, arguments));
    };
  }, fn1);
};
function once(fn) {
  var result;
  return function func() {
    if (fn) {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      result = fn.apply(this, args);
      fn = null;
    }
    return result;
  };
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function noop() {};
var warn = once(function (options) {
  var condition = options.condition,
    message = options.message;
  if (condition && __DEV__) {
    // eslint-disable-next-line no-console
    console.warn(message);
  }
});
var error = once(function (options) {
  var condition = options.condition,
    message = options.message;
  if (condition && __DEV__) {
    console.error(message);
  }
});
var promiseMicrotask = function promiseMicrotask(callback) {
  Promise.resolve().then(callback);
};
var scheduleMicrotask = __TEST__ ? function (fn) {
  return fn();
} : typeof queueMicrotask === 'function' ? queueMicrotask : promiseMicrotask;
var combineFunctions = function combineFunctions(a, b) {
  return function (v) {
    return b(a(v));
  };
};
var pipe = function pipe() {
  for (var _len6 = arguments.length, transformers = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    transformers[_key6] = arguments[_key6];
  }
  return transformers.reduce(combineFunctions);
};
var distance1D = function distance1D(a, b) {
  return Math.abs(a - b);
};
var isPoint = function isPoint(point) {
  return 'x' in point && 'y' in point;
};
function distance(a, b) {
  if (isNumber(a) && isNumber(b)) {
    return distance1D(a, b);
  }
  if (isPoint(a) && isPoint(b)) {
    var xDelta = distance1D(a.x, b.x);
    var yDelta = distance1D(a.y, b.y);
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
  }
  return 0;
}
function sleep() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (resolve) {
    setTimeout(resolve, delay);
  });
}

export { callAll, callAllHandlers, compose, distance, error, noop, once, pipe, runIfFn, scheduleMicrotask, sleep, warn };
//# sourceMappingURL=function.esm.js.map
